import Swal from 'sweetalert2';
import axios from 'axios';
import React, { useEffect } from 'react';
import { faArrowLeft, faServer } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

const InfoCargaMasiva = () => {
	const loadPage = () => {
		Swal.fire({
			title: 'Descarga de formato',
			text: 'El formato de Excel debe ser llenado con la información de los colaboradores, en caso que no lo poseas o quieras actualizarlo, puedes descargarlo aquí.',
			icon: 'info',
			showCancelButton: true,
			confirmButtonText: 'Descargar formato',
			cancelButtonText: 'Más tarde',
			allowOutsideClick: false
		}).then((result) => {
			if (result.isConfirmed) {
				const link = document.createElement("a");
				link.href = process.env.REACT_APP_API_URL + 'download-excel';
				link.download = 'import-form.xlsx';
				link.click();
			}
		});
	};

	const handleFile = async (e) => {
		e.preventDefault();

		let file = document.getElementById('excel-file').files[0];

		if (!file) {
			return Swal.fire({
				title: 'Hemos encontrado un inconveniente',
				text: 'Debes seleccionar un archivo',
				icon: 'warning',
				confirmButtonText: 'Aceptar'
			});
		}

		let config = {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		};

		let formData = new FormData();

		formData.append('file', file);

		try {
			let response = await axios.post(
				process.env.REACT_APP_API_URL + 'import-colaborator',
				formData,
				config
			);

			// Alera de proceso de carga
			Swal.fire({
				title: 'Procesando archivo',
				text: 'El archivo se está subiendo, por favor espera',
				icon: 'info',
				confirmButtonText: 'Aceptar',
				allowOutsideClick: false
			});

			if (response.status === 200) {
				Swal.fire({
					title: response.data.message,
					text: 'El archivo se ha subido correctamente',
					icon: 'success',
					confirmButtonText: 'Aceptar'
				});
			}
		} catch (error) {
			console.log(error);
			Swal.fire({
				title: 'Hemos encontrado un inconveniente',
				text: 'La lectura del archivo no se ha podido realizar',
				icon: 'warning',
				confirmButtonText: 'Aceptar'
			});
		}
	};

	useEffect(() => {
		// loadPage();
	}, []);


	return (
		<div className='w-auto mt-2 mx-6'>
			<div className="w-auto h-full mt-5 mx-4">
				<div className="flex flex-row justify-start items-center mb-4">
					<Link to="/Inicio" className="flex justify-start">
						<button className="bg-white border-4 border-[#0E7FA0] font-medium drop-shadow-2xl shadow-2xl text-white w-full rounded-full w-[50px] h-[50px] p-[12px] mr-3"><FontAwesomeIcon icon={faArrowLeft} className='text-[#0E7FA0] text-lg' /></button>
					</Link>
					<p className="text-4xl font-bold text-[#063E5F] text-center">Carga Masiva</p>
				</div>
				<div className='flex flex-wrap w-full md:h-[600px]'>
					<div className="w-full md:w-1/3 pb-5 md:px-5 md:pb-0 h-full">
						<div className="flex flex-col items-center justify-center bg-[#0E7FA0] rounded-xl text-white py-12 md:py-0 md:h-full">
							<div className="items-center mt-2">
								<FontAwesomeIcon icon={faServer} className="fa-user-plus text-[#0E7FA0] text-5xl rounded-full bg-white p-10" />
							</div>
							<h1 className="font-bold text-xl">Carga Masiva</h1>
						</div>
					</div>
					<div className="w-full md:w-2/3 h-full pb-5 md:px-5 md:pb-0">
						<div className="flex flex-col justify-center h-full">
							<div className="flex flex-wrap mb-5">
								<div className="w-full md:w-2/3 ">
									<h1 className="text-3xl text-[#0D7F9F] font-bold py-1">Descargar Formato</h1>
									<p className='text-gray-600'>Descarga el formato de Excel para subir los colaboradores de forma masiva</p>
								</div>
								<div className="w-full md:w-1/3">
									<div className='flex justify-center pt-2'>
										<button
											type="button"
											className="bg-[#99C33E] font-medium text-white rounded-full p-[12px] h-[50px]"
											data-discover="true"
											onClick={loadPage}
										>
											Descargar Formato
										</button>
									</div>
								</div>
							</div>
							<div className="w-full border-2 rounded-2xl p-3 flex flex-col justify-between">
								<div>
									<h1 className="text-3xl text-[#0D7F9F] font-bold mt-5 py-1">Subir Archivos</h1>
									<p className='text-gray-600'>Requerimientos para subir archivos de forma masiva: </p>
									<div className='flex items-center justify-center w-full'>
										<label className='flex flex-col border-4 border-dashed w-full h-40 hover:bg-gray-100 hover:border-slate-800 group'>
											<div className='flex flex-col items-center justify-center pt-7'>
												<svg className="w-10 h-10 text-slate-800 group-hover:text-gray-950" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
													<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
												</svg>
												<p className='text-lg text-gray-400 group-hover:text-gray-950 pt-1 tracking-wider'>
													Click aquí para seleccionar un archivo
												</p>
												<input
													type="file"
													className=""
													id="excel-file"
													name="excel-file"
												/>
											</div>
										</label>
									</div>
								</div>
								<div className='flex justify-center pt-2'>
									<div className='flex flex-row justify-between md:w-2/5'>
										<Link
											to="/Inicio"
											className="bg-[#E3087F] font-medium drop-shadow-2xl shadow-2xl text-white rounded-full p-[12px] h-[50px]"
											data-discover="true"
										>
											Cancelar Subida
										</Link>
										<button
											type="button"
											className="bg-[#99C33E] font-medium text-white rounded-full p-[12px] h-[50px]"
											data-discover="true"
											onClick={handleFile}
										>
											Subir Archivos
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default InfoCargaMasiva